import { toast } from 'react-toastify';
import { uniqueId } from 'lodash';
import api from '../../api';
import { NotificationPermissions } from './types';

export async function getNotificationPermissionsById(id: string) {
  try {
    const response = await api().get(`/notifications-permissions/${id}`);

    return response.data;
  } catch (error: any) {
    console.error(error?.response?.status);
    return null;
  }
}

export async function getNotificationPermissionsByUserId(userId: string) {
  try {
    const response = await api().get(
      `/notifications-permissions/user/${userId}`,
    );

    return response;
  } catch (error: any) {
    console.error(error?.response?.status);
    return null;
  }
}

export async function createNotificationsPermissions(
  userId: string,
  companyId: string,
  notificationsPermissions: NotificationPermissions,
) {
  try {
    const data = {
      ...notificationsPermissions,
    };
    const response = await api().post(
      `/notifications-permissions`,
      { data },
      {
        headers: {
          userId,
          companyId,
        },
      },
    );

    return response?.data;
  } catch (error: any) {
    console.error(error?.response?.status);
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function updateNotificationsPermissions(
  id: string,
  userId: string,
  companyId: string,
  notificationsPermissions: NotificationPermissions,
) {
  try {
    const data = { ...notificationsPermissions };
    const response = await api().patch(
      `/notifications-permissions/${id}`,
      data,
      {
        headers: {
          userId,
          companyId,
        },
      },
    );

    return response;
  } catch (error: any) {
    console.error(error?.response?.status);
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}
